const Logo = (props) => (
  <img
    className="logo"
    alt="Logo"
    // src="/static/logo.svg"
    src="/static/logo.png"
    style={{width: 52, height: 52}}
    {...props}
  />
);

export default Logo;
